import { FC } from 'react'

interface ProviderMonogramSVGProps {
  label: string
  background: string
  textColor?: string
  height?: number
  width?: number
  className?: string
}

/**
 * A simple colored-badge monogram (background + centered letters), used for
 * provider icons where we don't have an exact vector logo on hand — avoids
 * reproducing a trademarked mark inaccurately while still being visually
 * distinct per provider.
 */
export const ProviderMonogramSVG: FC<ProviderMonogramSVGProps> = ({
  label,
  background,
  textColor = '#ffffff',
  height = 40,
  width = 40,
  className
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <rect width="40" height="40" rx="8" fill={background} />
      <text
        x="50%"
        y="53%"
        dominantBaseline="middle"
        textAnchor="middle"
        fill={textColor}
        fontSize={label.length > 1 ? 15 : 19}
        fontWeight="600"
        fontFamily="system-ui, -apple-system, sans-serif"
      >
        {label}
      </text>
    </svg>
  )
}
